export const email = (value) => {
  let error;
  if (!value) {
    error = 'Required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = 'Invalid email address';
  }
  return error;
}

export const onlyNumbers = (value) => {
  let error;
  if (!value) {
    error = 'Required';
  } else if (value && !/^[0-9]*$/i.test(value)) {
    error = 'only numbers';
  }
  return error;
}


export const required = (value) => {
  let error;
  if (!value) {
    error = 'Required';
  }
  return error;
}